import { useEffect } from "react";
import { connectToState } from "../redux/connect-api";

const StateInitializer = ({ children, actions }) => {
  const { initializeAfterLogin } = actions;
  useEffect(() => {
    initializeAfterLogin?.();
  }, [initializeAfterLogin]);

  return children;
};

export default connectToState()(StateInitializer);
